<template>
  <v-dialog v-model="dialog" width="unset">
    <v-card v-if="payment" class="pa-8" style="width: 800px">
      <div id="invoice-box" class="invoice-box">
        <table cellpadding="0" cellspacing="0">
          <tr class="top">
            <td colspan="5">
              <table>
                <tr>
                  <td class="title">
                    <img :src="property.logo" style="max-width: 50px" />
                  </td>

                  <td>
                    Payment # {{ payment.refNo }}<br />
                    Created: {{ payment.date }}
                  </td>
                </tr>
              </table>
            </td>
          </tr>

          <tr class="information">
            <td colspan="5">
              <table>
                <tr>
                  <td>
                    {{ property.propertyName }}<br />{{ property.address1
                    }}<br />{{ property.address2 }}
                  </td>

                  <td>
                    {{ payment.tenantName }}<br />
                    {{ payment.email }}
                  </td>
                </tr>
              </table>
            </td>
          </tr>

          <tr class="heading">
            <td>Item</td>
            <td>Description</td>
            <td>Unit Cost</td>
            <td>Quantity</td>
            <td>Price</td>
          </tr>

          <tr v-for="item in allItems" :key="item._id" class="item">
            <td class="nowrap">{{ payment.category }}</td>
            <td>
              <span style="word-break: break-all; max-width: 50%">{{
                item.description || payment.category
              }}</span>
            </td>
            <td class="nowrap">
              {{ formatCurrency(item.amount / item.quantity) }}
            </td>
            <td class="nowrap">{{ item.quantity }}</td>
            <td class="nowrap">{{ formatCurrency(item.amount) }}</td>
          </tr>

          <!-- <tr>
            <td colspan="4">
              <button class="btn-add-row" @click="addRow">Add row</button>
            </td>
          </tr> -->

          <tr class="total">
            <td colspan="2"></td>
            <td colspan="3">Total: {{ formatCurrency(total) }}</td>
          </tr>
          <tr v-for="item in payment.adjustments" :key="item._id">
            <td colspan="2"></td>
            <td colspan="3">
              {{ item.description }}: {{ formatCurrency(item.value) }}
            </td>
          </tr>
          <tr>
            <td colspan="2"></td>
            <td colspan="3">
              Paid To Date: {{ formatCurrency(payment.amountPaid) }}
            </td>
          </tr>
        </table>
      </div>
      <v-card-actions>
        <div v-if="payment.attachments && payment.attachments.length > 0">
          <v-btn
            class="font-weight-bold"
            color="primary"
            depressed
            @click="downloadAttachments(payment.attachments)"
          >
            Download Attachments
          </v-btn>
        </div>
        <v-spacer></v-spacer>
        <v-btn class="font-weight-bold" text @click="print"> Print </v-btn>
        <v-btn
          class="font-weight-bold"
          color="primary"
          text
          @click="dialog = false"
        >
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { Printd } from 'printd'
export default {
  // props: ['property'],
  data() {
    return {
      d: new Printd(),
      dialog: false,
      payment: null
    }
  },
  computed: {
    total() {
      return this.allItems.reduce((acc, item) => {
        return acc + item.amount
      }, 0)
    },
    allItems() {
      return this.payment.items.concat(
        this.payment.paidItems.map((item) => {
          item.quantity = 1
          item.amount = -item.amount
          return item
        })
      )
    },
    property() {
      return this.$store.getters['properties/getProperty']
    }
  },
  methods: {
    open(params) {
      const { item } = params
      this.payment = JSON.parse(JSON.stringify(item))
      this.dialog = true
    },
    print() {
      this.d.print(document.getElementById('invoice-box'), [cssText])
    },
    downloadAttachments(attachments) {
      for (let i = 0; i < attachments.length; i++) {
        window.open(attachments[i].url)
      }
    },
    addRow() {
      this.payment.items.push({ description: '', quantity: 1, price: 0 })
    },
    formatCurrency(value) {
      if (value == null) return ''
      return parseFloat(value / 100).toLocaleString('en-PH', {
        style: 'currency',
        currency: 'PHP'
      })
    }
  }
}

const cssText = `
  .invoice-box {
    max-width: 800px;
    margin: auto;
    padding: 30px;
    border: 1px solid #eee;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.15);
    font-size: 16px;
    line-height: 24px;
    font-family: "Helvetica Neue", "Helvetica", Helvetica, Arial, sans-serif;
    color: #555;
  }

  .invoice-box table {
    width: 100%;
    line-height: inherit;
    text-align: left;
  }

  .invoice-box table td {
    padding: 5px;
    vertical-align: top;
  }

  .invoice-box table tr td:nth-child(n + 2) {
    text-align: right;
  }

  .invoice-box table tr.top table td {
    padding-bottom: 20px;
  }

  .invoice-box table tr.top table td.title {
    font-size: 45px;
    line-height: 45px;
    color: #333;
  }

  .invoice-box table tr.information table td {
    padding-bottom: 40px;
  }

  .invoice-box table tr.heading td {
    background: #eee;
    border-bottom: 1px solid #ddd;
    font-weight: bold;
  }

  .invoice-box table tr.details td {
    padding-bottom: 20px;
  }

  .invoice-box table tr.item td {
    border-bottom: 1px solid #eee;
  }

  .invoice-box table tr.item.last td {
    border-bottom: none;
  }

  .invoice-box table tr.item input {
    padding-left: 5px;
  }

  .invoice-box table tr.item td:first-child input {
    margin-left: -5px;
    width: 100%;
  }

  .invoice-box table tr.total td:nth-child(2) {
    border-top: 2px solid #eee;
    font-weight: bold;
  }

  .invoice-box input[type="number"] {
    width: 60px;
  }

  @media only screen and (max-width: 600px) {
    .invoice-box table tr.top table td {
      width: 100%;
      display: block;
      text-align: center;
    }

    .invoice-box table tr.information table td {
      width: 100%;
      display: block;
      text-align: center;
    }
  }

  /** RTL **/
  .rtl {
    direction: rtl;
    font-family: Tahoma, "Helvetica Neue", "Helvetica", Helvetica, Arial,
      sans-serif;
  }

  .rtl table {
    text-align: right;
  }

  .rtl table tr td:nth-child(2) {
    text-align: left;
  }
  `
</script>

<style scoped>
.invoice-box {
  max-width: 800px;
  margin: auto;
  padding: 30px;
  border: 1px solid #eee;
  border-radius: 0 !important;
  /*box-shadow: 0 0 10px rgba(0, 0, 0, 0.15);*/
  font-size: 16px;
  line-height: 24px;
  font-family: 'Helvetica Neue', 'Helvetica', Helvetica, Arial, sans-serif;
  color: #555;
}

.invoice-box table {
  width: 100%;
  line-height: inherit;
  text-align: left;
}

.invoice-box table td {
  padding: 5px;
  vertical-align: top;
}

.invoice-box table tr td:nth-child(n + 2) {
  text-align: right;
}

.invoice-box table tr.top table td {
  padding-bottom: 20px;
}

.invoice-box table tr.top table td.title {
  font-size: 45px;
  line-height: 45px;
  color: #333;
}

.invoice-box table tr.information table td {
  padding-bottom: 40px;
}

.invoice-box table tr.heading td {
  background: #eee;
  border-bottom: 1px solid #ddd;
  font-weight: bold;
}

.invoice-box table tr.details td {
  padding-bottom: 20px;
}

.invoice-box table tr.item td {
  border-bottom: 1px solid #eee;
}

.invoice-box table tr.item.last td {
  border-bottom: none;
}

.invoice-box table tr.item input {
  padding-left: 5px;
}

.invoice-box table tr.item td:first-child input {
  margin-left: -5px;
  width: 100%;
}

.invoice-box table tr.total td:nth-child(2) {
  border-top: 2px solid #eee;
  font-weight: bold;
}

.invoice-box input[type='number'] {
  width: 60px;
}

@media only screen and (max-width: 600px) {
  .invoice-box table tr.top table td {
    width: 100%;
    display: block;
    text-align: center;
  }

  .invoice-box table tr.information table td {
    width: 100%;
    display: block;
    text-align: center;
  }
}

/** RTL **/
.rtl {
  direction: rtl;
  font-family: Tahoma, 'Helvetica Neue', 'Helvetica', Helvetica, Arial,
    sans-serif;
}

.rtl table {
  text-align: right;
}

.rtl table tr td:nth-child(2) {
  text-align: left;
}

.nowrap {
  white-space: nowrap;
}
</style>
